module.exports = __webpack_public_path__ + "static/media/banner_420x230_9.6d86d3bf.jpg";